import React from "react";
import Select from "react-select";
import AppIcon from "../../components/app-icon";
import { ObjectHash } from "../../utils/helpers";
import { customStyle } from "../form/inputs/custom-theme";

interface Props {
  defaultValue: "are" | "is" | "is not";
  isDisabled?: boolean;
  onChange?: CallableFunction;
}

const articleOpts = [
  { label: "Is", value: "is" },
  { label: "Is Not", value: "is not" }
];

export default function ArticleSelect(props: Props) {
  const { defaultValue, isDisabled, onChange } = props;

  const { menuPortal } = customStyle;

  const optionStyles = {
    container: (styles: ObjectHash) => ({
      ...styles,
      width: "100%"
    }),
    control: (styles: ObjectHash) => ({
      ...styles,
      borderWidth: "2px",
      paddingRight: "8px",
      height: 40,
      width: "100%"
    }),
    menuPortal
  };

  return (
    <Select
      options={articleOpts}
      components={{
        DropdownIndicator: () => <AppIcon type="menu-arrow" />,
        IndicatorSeparator: () => null
      }}
      onChange={(...args) => {
        if (onChange) {
          onChange(...args);
        }
      }}
      defaultValue={articleOpts.find(
        (opt: ObjectHash) => opt.value === defaultValue
      )}
      isDisabled={isDisabled}
      styles={optionStyles}
    />
  );
}
